import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { restaurantSaveTimes } from '../../../store/Restaurant/api';

export const useSetStoreTimes = () => {
    return useMutation(
        ['editStoreTimes'],
        ({ id, times }) => {
            Object.keys(times).forEach((time) => {
                times[time].enabled = times[time].status === 'enabled';
            });
            return restaurantSaveTimes(id, { times: times });
        },
        {
            onError: (error) => {
                toast.error(error.response?.data?.message);
            },
        }
    );
};
